import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-5d9c7a6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "h-screen w-screen flex flex-col overflow-hidden" };
const _hoisted_2 = { class: "h-10/100 w-full" };
const _hoisted_3 = { class: "h-10/100 w-full py-8 bg-backgroundOfForm" };
const _hoisted_4 = { class: "stepper-wrapper" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "1", -1));
const _hoisted_6 = { class: "step-name" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "2", -1));
const _hoisted_8 = { class: "step-name" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "3", -1));
const _hoisted_10 = { class: "step-name" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "4", -1));
const _hoisted_12 = { class: "step-name" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "5", -1));
const _hoisted_14 = { class: "step-name" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-counter" }, "6", -1));
const _hoisted_16 = { class: "step-name" };
const _hoisted_17 = { class: "flex-grow overflow-scroll bg-backgroundOfForm" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = { key: 3 };
const _hoisted_22 = { key: 4 };
const _hoisted_23 = { key: 5 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AdminUIHeader = _resolveComponent("AdminUIHeader");
    const _component_RegisterEmailForm = _resolveComponent("RegisterEmailForm");
    const _component_ContactInformation = _resolveComponent("ContactInformation");
    const _component_CompanyCheckForm = _resolveComponent("CompanyCheckForm");
    const _component_CompanyInformationsForm = _resolveComponent("CompanyInformationsForm");
    const _component_RightsForm = _resolveComponent("RightsForm");
    const _component_SummaryForm = _resolveComponent("SummaryForm");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_AdminUIHeader)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[1],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[1],
                            })
                        }, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.stepper_contact_information')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[2],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[2],
                            })
                        }, [
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('admin-ui.stepper_identity')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[4],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[4],
                            })
                        }, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('admin-ui.stepper_checking_vat')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[5],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[5],
                            })
                        }, [
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('admin-ui.stepper_company_information')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[6],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[6],
                            })
                        }, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('admin-ui.stepper_rights')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass({
                                'stepper-item active': _ctx.stateListOfFormsToShow[7],
                                'stepper-item completed': !_ctx.stateListOfFormsToShow[7],
                            })
                        }, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('admin-ui.stepper_summary')), 1)
                        ], 2)
                    ])
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                        (_ctx.nbrCurrentShowToForm === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(_component_RegisterEmailForm, {
                                    "show-mobile-version": _ctx.showMobileVersion,
                                    "show-banner": _ctx.showBanner,
                                    "text-banner": _ctx.textBanner,
                                    "show-animation-banner": _ctx.showAnimationBanner,
                                    onSendMail: _ctx.sendUserEmail,
                                    onClose: _ctx.closeBanner
                                }, null, 8, ["show-mobile-version", "show-banner", "text-banner", "show-animation-banner", "onSendMail", "onClose"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.nbrCurrentShowToForm === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(_component_ContactInformation, {
                                    "show-mobile-version": _ctx.showMobileVersion,
                                    "show-banner": _ctx.showBanner,
                                    "text-banner": _ctx.textBanner,
                                    "show-animation-banner": _ctx.showAnimationBanner,
                                    "error-fetch-api": _ctx.canGetCustomerEmail,
                                    "user-retrieved-data": _ctx.userRetrievedData,
                                    "user-data": _ctx.myUser,
                                    onNextClick: _ctx.checkContactForm,
                                    onClose: _ctx.closeBanner
                                }, null, 8, ["show-mobile-version", "show-banner", "text-banner", "show-animation-banner", "error-fetch-api", "user-retrieved-data", "user-data", "onNextClick", "onClose"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.nbrCurrentShowToForm === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createVNode(_component_CompanyCheckForm, {
                                    "nbr-of-request-api-made": _ctx.nbrRequestApiCheckVat,
                                    "error-api": _ctx.hasVatErrorAPI,
                                    "message-api": _ctx.messageVatAPI,
                                    "is-checking-vat-api": _ctx.isCheckingVat,
                                    "my-object": _ctx.myUser,
                                    onNextClick: _ctx.CheckVatForm,
                                    onPreviousClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showForm(2)))
                                }, null, 8, ["nbr-of-request-api-made", "error-api", "message-api", "is-checking-vat-api", "my-object", "onNextClick"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.nbrCurrentShowToForm === 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_component_CompanyInformationsForm, {
                                    "my-object": _ctx.myUser,
                                    onNextClick: _ctx.checkCompanyInformationsForm,
                                    onPreviousClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showForm(4)))
                                }, null, 8, ["my-object", "onNextClick"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.nbrCurrentShowToForm === 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_RightsForm, {
                                    "my-object": _ctx.myUser,
                                    onNextClick: _ctx.checkRightsForm,
                                    onPreviousClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showForm(5)))
                                }, null, 8, ["my-object", "onNextClick"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.nbrCurrentShowToForm === 7)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createVNode(_component_SummaryForm, {
                                    "my-object": _ctx.myUser,
                                    onPreviousClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showForm(6)))
                                }, null, 8, ["my-object"])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ])
    ]));
}
